<template>
    <b-card>
        <signature-pad ref="spad"></signature-pad>
        <button v-on:click="getSpad">get</button>
    </b-card>
</template>

<script>
import {BCard,BButton} from 'bootstrap-vue'
import SignaturePad from '@/components/SignaturePad.vue'


export default {
    components:{
        BCard,
        BButton,
        SignaturePad
    },
    data(){
        return{
            
        }
    },
    mounted(){
    },
    methods:{
        getSpad(){
            console.log(this.$refs.spad.get())
        }
    }
}
</script>

<style>

</style>